import { c as _c } from "react/compiler-runtime";
import { Button } from '@/app/components/button';
import type { SpartanProductCustomizePreviewInfoProps } from '@/app/lcv/components/sections/spartan/products/customize/configurator/preview-info/types';
import { SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA, SPARTAN_PRODUCT_CUSTOMIZE_TRACKING } from '@/app/lcv/components/sections/spartan/products/customize/tracking';
import { SPARTAN_PRODUCT_BUTTON_CLASS_NAME, SPARTAN_PRODUCT_BUTTON_SECONDARY_CLASS_NAME } from '@/app/lcv/components/sections/spartan/products/shared/icon-button';
import { SPARTAN_PRODUCTS_EVENT_NAME } from '@/app/lcv/components/sections/spartan/products/shared/tracking';
import { SPARTAN_PRODUCT_CUSTOMIZE_LABELS } from '@/app/lcv/contents/spartan/products/shared/customize-common-fields.data';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';
import { formatPrice } from '@/app/utils/format';
export const SpartanProductCustomizePreviewInfo = t0 => {
  const $ = _c(44);
  const {
    placement,
    modelName,
    modelLabel,
    totalPrice,
    compareUrl,
    calculatorUrl,
    tone: t1,
    surface
  } = t0;
  const tone = t1 === undefined ? "light" : t1;
  const isDark = tone === "dark";
  const isSolidSurface = (surface ?? (isDark ? "solid" : "transparent")) === "solid";
  const t2 = isDark ? "text-white" : "text-gray-900";
  const t3 = isSolidSurface ? "bg-gray-900" : "bg-transparent";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = cn("relative flex min-w-0 flex-col gap-3 px-4 py-4 transition-[background-color,color] duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] motion-reduce:transition-none md:gap-4 md:p-4 xl:flex-row xl:items-center xl:justify-between", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== placement) {
    t5 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewInfo(placement)
    });
    $[3] = placement;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== placement) {
    t6 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewInfoText(placement)
    });
    $[5] = placement;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== modelName || $[8] !== placement) {
    t7 = !!modelName && <span {...createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewModelName(placement)
    })}>{modelName}{" "}</span>;
    $[7] = modelName;
    $[8] = placement;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== placement) {
    t8 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewGrade(placement)
    });
    $[10] = placement;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== modelLabel || $[13] !== t8) {
    t9 = <span {...t8}>{modelLabel}</span>;
    $[12] = modelLabel;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t7 || $[16] !== t9) {
    t10 = <p className="text-body-1 hidden lg:block">{t7}{t9}</p>;
    $[15] = t7;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== placement || $[19] !== totalPrice) {
    t11 = totalPrice !== null && <p className="text-body-1-fixed lg:text-body-1 font-noto-bold flex w-full items-baseline justify-between gap-4 xl:w-auto xl:justify-start xl:gap-1" {...createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewPrice(placement)
    })}><span {...createDataAttributes({
        test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewPriceLabel(placement)
      })}>{SPARTAN_PRODUCT_CUSTOMIZE_LABELS.totalPricePrefix}</span><span {...createDataAttributes({
        test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewPriceValue(placement)
      })}>{formatPrice(totalPrice)}</span></p>;
    $[18] = placement;
    $[19] = totalPrice;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11 || $[23] !== t6) {
    t12 = <div className="relative flex w-full min-w-0 flex-col gap-1 lg:w-auto" {...t6}>{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t6;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== placement) {
    t13 = createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewActions(placement)
    });
    $[25] = placement;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== compareUrl || $[28] !== isDark || $[29] !== placement) {
    t14 = !!compareUrl && <Button href={compareUrl} color={isDark ? "white" : "black"} variant="secondary" size="sm" width="min" className={cn("min-w-0 flex-1 xl:min-w-39 xl:flex-none", SPARTAN_PRODUCT_BUTTON_SECONDARY_CLASS_NAME)} {...createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewCompare(placement)
    })} {...createDataGA({
      eventName: SPARTAN_PRODUCTS_EVENT_NAME,
      group: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.section,
      click: true,
      text: SPARTAN_PRODUCT_CUSTOMIZE_LABELS.compare,
      url: compareUrl,
      value: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.compare
    })}>{SPARTAN_PRODUCT_CUSTOMIZE_LABELS.compare}</Button>;
    $[27] = compareUrl;
    $[28] = isDark;
    $[29] = placement;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== calculatorUrl || $[32] !== isDark || $[33] !== placement) {
    t15 = !!calculatorUrl && <Button href={calculatorUrl} color={isDark ? "white" : "black"} size="sm" width="min" className={cn("min-w-0 flex-1 xl:min-w-39 xl:flex-none", SPARTAN_PRODUCT_BUTTON_CLASS_NAME)} {...createDataAttributes({
      test: SPARTAN_PRODUCT_CUSTOMIZE_TRACKING.previewCalculator(placement)
    })} {...createDataGA({
      eventName: SPARTAN_PRODUCTS_EVENT_NAME,
      group: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.section,
      click: true,
      text: SPARTAN_PRODUCT_CUSTOMIZE_LABELS.calculator,
      url: calculatorUrl,
      value: SPARTAN_PRODUCT_CUSTOMIZE_DATA_GA.calculator
    })}>{SPARTAN_PRODUCT_CUSTOMIZE_LABELS.calculator}</Button>;
    $[31] = calculatorUrl;
    $[32] = isDark;
    $[33] = placement;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== t13 || $[36] !== t14 || $[37] !== t15) {
    t16 = <div className="flex w-full min-w-0 flex-row gap-4 xl:w-auto xl:shrink-0" {...t13}>{t14}{t15}</div>;
    $[35] = t13;
    $[36] = t14;
    $[37] = t15;
    $[38] = t16;
  } else {
    t16 = $[38];
  }
  let t17;
  if ($[39] !== t12 || $[40] !== t16 || $[41] !== t4 || $[42] !== t5) {
    t17 = <div className={t4} {...t5}>{t12}{t16}</div>;
    $[39] = t12;
    $[40] = t16;
    $[41] = t4;
    $[42] = t5;
    $[43] = t17;
  } else {
    t17 = $[43];
  }
  return t17;
};